// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f12ee7f4","canvas":"d2b2cde7","input":"b18dcd3b"};